import { render } from "./HouseImage.vue?vue&type=template&id=62937520"
import script from "./HouseImage.vue?vue&type=script&lang=js"
export * from "./HouseImage.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__